import { createUseStyles } from 'react-jss'

const useStyles = createUseStyles({
  imagesLabel: {
    display: 'inline-block',
    marginBottom: '.313rem',
    textTransform: 'uppercase',
    fontSize: '.813rem',
    fontWeight: 'bold',
  },

  imagesHeader: {
    display: 'flex',
    marginBottom: '1rem',
    alignItems: 'center',
    borderBottom: '.0631rem solid #ddd',
  },

  datasetManager: {
    display: '-webkit-inline-box',
    float: 'right',
  },

  hiddenDatasetManager: {
    display: 'none',
  },

  tableActionsCell: {
    display: 'flex',
  },

  modalErrorLineText: {
    paddingTop: '0.5rem',
  },

  loadingToast: {
    position: 'fixed',
    bottom: '20px',
    right: '20px',
    backgroundColor: 'rgba(255, 255, 255, 0.95)',
    border: '1px solid #ddd',
    borderRadius: '8px',
    padding: '12px 16px',
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
    zIndex: 1000,
    cursor: 'wait',
    boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
  },

  loadingSpinner: {
    width: '24px',
    height: '24px',
    border: '3px solid #f3f3f3',
    borderTop: '3px solid #3498db',
    borderRadius: '50%',
    animation: '$spin 1s linear infinite',
  },

  loadingText: {
    color: '#666',
    fontSize: '14px',
    fontWeight: '500',
  },

  browserContainer: {
    position: 'relative',
  },

  loadingOverlay: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(255, 255, 255, 0.6)',
    zIndex: 100,
    cursor: 'not-allowed',
    pointerEvents: 'none',
  },

  datasetImagesInfo: {
    color: '#666',
  },

  '@keyframes spin': {
    '0%': { transform: 'rotate(0deg)' },
    '100%': { transform: 'rotate(360deg)' },
  },

  relative: {
    position: 'relative',
  },
})

export default useStyles
